(function () {
  angular
    .module("akitabox.core.services.issueType", [
      "akitabox.constants",
      "akitabox.core.services.building",
      "akitabox.core.services.http",
      "angular-cache",
    ])
    .factory("IssueTypeService", IssueTypeService);

  /** @ngInject */
  function IssueTypeService(
    // Constants
    models,
    // Services
    HttpService
    // Third-party
    // CacheFactory
  ) {
    var cache;

    init();

    function init() {
      // TODO: Re-add once types are moved to organization-level
      // cache = CacheFactory.get("issueTypes");
      // if (!cache) {
      //   cache = CacheFactory("issueTypes");
      // }
    }

    var service = {
      // Routes
      buildBaseRoute: buildBaseRoute,
      buildDetailRoute: buildDetailRoute,
      buildListRoute: buildListRoute,
      // Retrieve
      get: get,
      getById: getById,
      getAll: getAll,
    };

    return service;

    // ------------------------
    //   Public Functions
    // ------------------------

    /******************* *
     *   Routes
     * ****************** */

    function buildBaseRoute(buildingId) {
      return (
        "/" +
        models.BUILDING.ROUTE_PLURAL +
        "/" +
        buildingId +
        "/" +
        models.ISSUE_TYPE.ROUTE_PLURAL
      );
    }

    function buildDetailRoute(buildingId, issueTypeId) {
      var base = buildBaseRoute(buildingId);
      return base + "/" + issueTypeId;
    }

    function buildListRoute(buildingId) {
      return buildBaseRoute(buildingId);
    }

    /******************* *
     *   Retrieve
     * ****************** */

    function get(buildingId, params, options) {
      var route = buildListRoute(buildingId);
      // TODO: Re-add once types are moved to organization-level
      // if (options && !options.cache) {
      //   return HttpService.get(route, params);
      // }
      return HttpService.get(route, params, cache);
    }

    function getAll(buildingId, params, options) {
      var route = buildListRoute(buildingId);
      // TODO: Re-add once types are moved to organization-level
      // if (options && !options.cache) {
      //   return HttpService.getAll(route, params);
      // }
      return HttpService.getAll(route, params, cache);
    }

    function getById(buildingId, issueTypeId, params, options) {
      var route = buildDetailRoute(buildingId, issueTypeId);
      // TODO: Re-add once types are moved to organization-level
      // if (options && !options.cache) {
      //   return HttpService.getById(route, issueTypeId, params);
      // }
      return HttpService.getById(route, issueTypeId, params, cache);
    }
  }
})();
